import PropTypes from 'prop-types';
import ThreadCard from './thread-card';

const ThreadList = ({ threadReplies }) => {
  return (
    <div style={{ width: '95%', margin: '0 auto' }}>
      {threadReplies.map((thread, i) => (
        <ThreadCard key={thread.id} email={thread} isLastEmail={i === threadReplies.length - 1} />
      ))}
    </div>
  );
};

ThreadList.propTypes = {
  threadReplies: PropTypes.array,
};

export default ThreadList;
